import { MentorDashboardKpis } from './MentorPortalService';
import { durationSubline, formatMonthYy } from './mentorDashboardFormat';

type Props = {
    kpis: MentorDashboardKpis;
};

const MentorKpiCards = ({ kpis }: Props) => {
    const assigned = kpis.menteesAssigned ?? 0;
    const cap = kpis.maxMenteesPerMentor;
    const sessions = kpis.sessionsCompletedInWindow ?? 0;
    const durationValue = formatMonthYy(kpis.cohortStartDate) || '—';
    const durationSub = durationSubline(kpis.cohortStartDate, kpis.cohortEndDate) || '—';

    return (
        <>
            
        <div className="row g-3 mb-3">
              <div className="col-12 col-sm-6 col-lg-3">
                <div className="card border-0 shadow-sm rounded-3 p-3 bg-white h-100">
                  <div className="small fw-bold text-muted text-uppercase tracking-wider font-11 mb-2">Mentees Assigned</div>
                  <div className="fs-2 fw-bold text-primary lh-1">{assigned}</div>
                  <div className="text-secondary small mt-2">{cap == null ? 'Max capacity: —' : `Max capacity: ${cap}`}</div>
                </div>
              </div>
              <div className="col-12 col-sm-6 col-lg-3">
                <div className="card border-0 shadow-sm rounded-3 p-3 bg-white h-100">
                  <div className="small fw-bold text-muted text-uppercase tracking-wider font-11 mb-2">Sessions Completed</div>
                  <div className="fs-2 fw-bold text-success lh-1">{sessions}</div>
                  <div className="text-secondary small mt-2">—</div>
                </div>
              </div>
              <div className="col-12 col-sm-6 col-lg-3">
                <div className="card border-0 shadow-sm rounded-3 p-3 bg-white h-100">
                  <div className="small fw-bold text-muted text-uppercase tracking-wider font-11 mb-2">Unread Messages</div>
                  <div className="fs-2 fw-bold text-danger lh-1">{kpis.unreadMessages || '—'}</div>
                  <div className="text-secondary small mt-2">Available with Messages</div>
                </div>
              </div>
              <div className="col-12 col-sm-6 col-lg-3">
                <div className="card border-0 shadow-sm rounded-3 p-3 bg-white h-100">
                  <div className="small fw-bold text-muted text-uppercase tracking-wider font-11 mb-2">Cohort Duration</div>
                  <div className="fs-2 fw-bold text-dark lh-1">{durationValue}</div>
                  <div className="text-secondary small mt-2">{durationSub}</div>
                </div>
              </div>
            </div>
        </>
    );
};

export default MentorKpiCards;
